import styled from "styled-components";

export const StatusDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  border-radius: 50px;
  background-color: ${(props) => props.color};
  padding: ${(props) => (props.isMini ? "0px 8px;" : "0px 12px;")};
  width: fit-content;
  white-space: nowrap;
  font-size: ${(props) => (props.isMini ? 10 : 13)}px;
  height: ${(props) => (props.isMini ? 20 : 25)}px;

  span {
    text-align: center;
    font-weight: 600;
    color: #fff;
  }
`;
